export default {
  computed: {
    getAppMode() {
      return this.$store.state.common.appMode;
    }
  },
  methods: {
    routerLink($event, redirectTo) {
      // redirect to page
      if (redirectTo) {
        this.$router.push({ path: redirectTo.url, query: redirectTo.params });
      } else {
        const href = {};
        this.findHref($event.target, href, 2, 0);

        const exactMatchSafeList = [
          // Homepage
          "/",

          // Contact us
          "/contact",

          // About pages
          "/about-us",
          "/ten-reasons",
          "/our-story",
          "/5-reasons-to-book-early",
          "/rent-your-villa-with-us",
          "/white-key",
          "/think-exquisite-luxury-villas",

          // Information pages
          "/conde-nast-traveller-readers-travel-awards",
          "/client-reviews",
          "/terms-of-use",
          "/cookie-information",
          "/responsible-business",
          "/what-to-expect",
          "/privacy-policy",

          // Experiences (Greece pages that will redirect to Island groupings)
          "/greece/corfu/experiences",
          "/greece/paxos-and-antipaxos/experiences",
          "/greece/meganissi/experiences",
          "/greece/kastos/experiences",
          "/greece/lefkada/experiences",
          "/greece/alonissos/experiences",
          "/greece/skopelos/experiences",
          "/greece/zakynthos/experiences",

          // France
          "/france",
          "/france/corsica",
          "/france/corsica/towns-and-cities-in-corsica/ajaccio",
          "/france/corsica/towns-and-cities-in-corsica/bonifacio",
          "/france/corsica/towns-and-cities-in-corsica/calvi",
          "/france/corsica/towns-and-cities-in-corsica/porto-vecchio",
          "/france/corsica/towns-and-cities-in-corsica/sartene",

          // Greece
          "/greece",
          "/greece/corinth",
          "/greece/aegina",
          "/greece/alonissos",
          "/greece/alonissos/towns-and-cities-of-alonissos/alonissos-old-town",
          "/greece/antiparos",
          "/greece/corfu",
          "/greece/corfu/towns-and-cities-in-corfu/corfu-town",
          "/greece/corfu/towns-and-cities-in-corfu/old-perithia",
          "/greece/cyclades",
          "/greece/dodecanese",
          "/greece/evia",
          "/greece/hydra",
          "/greece/ionian",
          "/greece/kastos",
          "/greece/kea",
          "/greece/kefalonia",
          "/greece/lefkada",
          "/greece/lefkada/towns-and-cities-of-lefkada/lefkada-town",
          "/greece/mainland",
          "/greece/meganissi",
          "/greece/mykonos",
          "/greece/paros",
          "/greece/patmos",
          "/greece/paxos-and-antipaxos",
          "/greece/porto-heli",
          "/greece/saronic",
          "/greece/serifos",
          "/greece/skiathos",
          "/greece/skopelos",
          "/greece/skopelos/towns-and-cities-on-skopelos/skopelos-town",
          "/greece/spetses",
          "/greece/sporades",
          "/greece/syros",
          "/greece/tinos",
          "/greece/zakynthos",

          // Italy
          "/italy",
          "/italy/puglia",
          "/italy/puglia/the-salento",
          "/italy/puglia/valle-d-itria",
          "/italy/puglia/towns-and-cities-in-puglia/alberobello",
          "/italy/puglia/towns-and-cities-in-puglia/bari",
          "/italy/puglia/towns-and-cities-in-puglia/brindisi",
          // '/italy/puglia/towns-and-cities-in-puglia/castro',
          "/italy/puglia/towns-and-cities-in-puglia/cisternino",
          "/italy/puglia/towns-and-cities-in-puglia/galatina",
          "/italy/puglia/towns-and-cities-in-puglia/gallipoli",
          "/italy/puglia/towns-and-cities-in-puglia/lecce",
          "/italy/puglia/towns-and-cities-in-puglia/locorotondo",
          "/italy/puglia/towns-and-cities-in-puglia/martina-franca",
          "/italy/puglia/towns-and-cities-in-puglia/matera",
          "/italy/puglia/towns-and-cities-in-puglia/monopoli",
          "/italy/puglia/towns-and-cities-in-puglia/ostuni",
          "/italy/puglia/towns-and-cities-in-puglia/otranto",
          "/italy/puglia/towns-and-cities-in-puglia/polignano-a-mare",
          "/italy/puglia/towns-and-cities-in-puglia/santa-maria-di-leuca",
          // '/italy/puglia/towns-and-cities-in-puglia/specchia'
          "/italy/puglia/towns-and-cities-in-puglia/taranto",
          "/italy/puglia/towns-and-cities-in-puglia/trani",

          "/italy/sicily",
          "/italy/sicily/aeolian-islands",
          "/italy/sicily/egadi-islands",
          "/italy/sicily/ionian-riviera",
          "/italy/sicily/north-coast",
          "/italy/sicily/syracuse",
          "/italy/sicily/val-di-noto",
          "/italy/sicily/western-sicily",
          "/italy/sicily/mount-etna",
          "/italy/sicily/towns-and-cities-in-sicily/acireale",
          // '/italy/sicily/towns-and-cities-in-sicily/agira',
          // '/italy/sicily/towns-and-cities-in-sicily/agrigento',
          "/italy/sicily/towns-and-cities-in-sicily/caltagirone",
          "/italy/sicily/towns-and-cities-in-sicily/castellammare-del-golfo",
          "/italy/sicily/towns-and-cities-in-sicily/catania",
          "/italy/sicily/towns-and-cities-in-sicily/cefalu",
          // '/italy/sicily/towns-and-cities-in-sicily/chiaramonte-gulfi',
          // '/italy/sicily/towns-and-cities-in-sicily/enna',
          "/italy/sicily/towns-and-cities-in-sicily/erice",
          "/italy/sicily/towns-and-cities-in-sicily/marsala",
          "/italy/sicily/towns-and-cities-in-sicily/marzamemi",
          "/italy/sicily/towns-and-cities-in-sicily/mazara-del-vallo",
          "/italy/sicily/towns-and-cities-in-sicily/menfi",
          // '/italy/sicily/towns-and-cities-in-sicily/messina',
          "/italy/sicily/towns-and-cities-in-sicily/milazzo",
          "/italy/sicily/towns-and-cities-in-sicily/modica",
          "/italy/sicily/towns-and-cities-in-sicily/mondello",
          // '/italy/sicily/towns-and-cities-in-sicily/monreale',
          "/italy/sicily/towns-and-cities-in-sicily/noto",
          // '/italy/sicily/towns-and-cities-in-sicily/palazzolo-acreide',
          "/italy/sicily/towns-and-cities-in-sicily/palermo",
          "/italy/sicily/towns-and-cities-in-sicily/piazza-armerina",
          "/italy/sicily/towns-and-cities-in-sicily/pozzallo",
          "/italy/sicily/towns-and-cities-in-sicily/ragusa",
          "/italy/sicily/towns-and-cities-in-sicily/sciacca",
          "/italy/sicily/towns-and-cities-in-sicily/scicli",
          "/italy/sicily/towns-and-cities-in-sicily/scopello",
          "/italy/sicily/towns-and-cities-in-sicily/syracuse",
          "/italy/sicily/towns-and-cities-in-sicily/taormina",
          "/italy/sicily/towns-and-cities-in-sicily/trapani",
          "/italy/sicily/",

          // Tuscany redirect from CMS to Builder in order to use page ID and page type
          "/italy/lazio",
          "/italy/tuscany/florence",
          "/italy/tuscany/tuscany-coast",

          // Areas of... pages
          "/italy/sicily/areas-of-sicily",
          "/italy/sicily/areas-of-sicily/islands-and-archipelagos",
          "/italy/puglia/areas-of-puglia",
          "/france/corsica/areas",
          "/greece/corfu/areas",
          "/greece/paxos-and-antipaxos/areas",
          "/greece/meganissi/areas",
          "/greece/kastos/areas",
          "/greece/lefkada/areas",
          "/greece/alonissos/areas-of-alonissos",
          "/greece/skopelos/areas",
          "/greece/cyclades/areas",
          "/greece/mykonos/areas",
          "/greece/kefalonia/areas",
          "/greece/skiathos/areas",
          "/greece/serifos/areas",
          "/greece/patmos/areas",

          // Beaches
          "/italy/sicily/beaches-in-sicily",
          "/italy/puglia/beaches-in-puglia",
          "/france/corsica/beaches",
          "/greece/corfu/beaches",
          "/greece/paxos-and-antipaxos/beaches",
          "/greece/meganissi/beaches",
          "/greece/lefkada/beaches",
          "/greece/alonissos/beaches",
          "/greece/skopelos/beaches",
          "/greece/zakynthos/beaches",
          "/greece/aegina/beaches",
          "/greece/hydra/beaches",
          "/greece/antiparos/beaches",
          "/greece/paros/beaches",
          "/greece/mykonos/beaches",
          "/greece/syros/beaches",
          "/greece/tinos/beaches",
          "/greece/kefalonia/beaches",
          "/greece/skiathos/beaches",
          "/greece/kea/beaches",
          "/greece/serifos/beaches",
          "/greece/patmos/beaches",

          // History of...
          "/italy/sicily/guide-to-sicily/history-of-sicily",
          "/greece/mainland/history",
          "/greece/cyclades/history",
          "/greece/saronic/history",
          "/greece/sporades/history",
          "/greece/ionian/history",

          // Food and wine
          "/italy/sicily/food-and-wine",
          "/italy/puglia/food-and-wine",
          "/france/corsica/food-and-wine",

          // Weather pages
          "/italy/sicily/weather",
          "/italy/puglia/weather",
          "/france/corsica/weather",
          "/greece/weather",

          // Collections
          "/all-in-the-detail",
          "/all-our-villas-on-the-sea",
          "/all-villas-in-southern-italy",
          "/all-villas-in-the-ionian-islands",
          "/all-villas-with-heated-pools",
          "/all-villas-with-sports-facilities",
          "/all-villas-within-walking-distance-of-shops-and-restaurants",
          "/authentic-italian-villas",
          "/availability-villas",
          "/car-free-villas-greece",
          "/car-free,-care-free-in-the-mediterranean",
          "/classic-greek-villas",
          "/contemporary-design-villas-in-the-mediterranean",
          "/cosmopolitan-villas-greece",
          "/cosmopolitan-villas",
          "/flexible-stay-villas-in-the-mediterranean",
          "/france/corsica/all-villas-in-corsica",
          "/france/corsica/corsica-villas-near-restaurants",
          "/france/corsica/corsica-villas-with-pools",
          "/france/corsica/large-family-villas-corsica",
          "/france/corsica/modern-design-villas-corsica",
          "/france/corsica/seafront-villas-in-corsica",
          "/france/corsica/villas-in-corsica-near-bonifacio",
          "/france/corsica/villas-in-corsica-near-porto-vecchio",
          "/france/corsica/villas-in-corsica-near-valinco",
          "/greece/aegina/villas-on-aegina",
          "/greece/alonissos/villas-on-alonissos",
          "/greece/antiparos/villas-on-antiparos",
          "/greece/corfu/villas-on-corfu",
          "/greece/evia/villas-on-evia",
          "/greece/greece/large-greek-villas",
          "/greece/greece/long-stay-villas-in-greece",
          "/greece/greece/villas-for-long-stays",
          "/greece/greece/villas-on-the-athens-riviera",
          "/greece/hydra/villas-on-hydra",
          "/greece/kastos/villas-on-kastos",
          "/greece/kea/villas-on-kea",
          "/greece/kefalonia/villas-on-kefalonia",
          "/greece/lefkada/all-villas-on-lefkada",
          "/greece/meganissi/villas-on-meganissi",
          "/greece/mykonos/villas-on-mykonos",
          "/greece/paros/villas-in-paros",
          "/greece/patmos/villas-in-the-dodecanese",
          "/greece/patmos/villas-on-patmos",
          "/greece/porto-heli/villas-in-porto-heli",
          "/greece/serifos/villas-in-serifos",
          "/greece/skiathos/villas-on-skiathos",
          "/greece/skopelos/villas-on-skopelos",
          "/greece/spetses/villas-on-spetses",
          "/greece/syros/villas-on-syros",
          "/greece/tinos/villas-on-tinos",
          "/greece/zakynthos/all-villas-in-zakynthos",
          "/greek-family-villas",
          "/greek-villas-by-the-beach",
          "/greek-villas-with-pools",
          "/historic-properties-palaces-castles-and-aristocratic-houses",
          "/italian-coast-villas",
          "/italy/puglia/all-villas-in-puglia",
          "/italy/puglia/countryside-villas-in-puglia",
          "/italy/puglia/family-villas-puglia",
          "/italy/puglia/romantic-and-honeymoon-villas",
          "/italy/puglia/trulli-in-puglia",
          "/italy/puglia/villas-in-puglia-by-the-sea",
          "/italy/puglia/villas-in-puglia-in-the-valle-ditria",
          "/italy/puglia/villas-in-puglia-near-santa-maria-di-leuca",
          "/italy/puglia/villas-in-the-salento",
          "/italy/puglia/villas-near-bari",
          "/italy/puglia/villas-near-lecce",
          "/italy/puglia/villas-near-ostuni",
          "/italy/puglia/villas-near-otranto",
          "/italy/puglia/villas-with-pools-in-puglia",
          "/italy/sicily/all-villas-in-sicily",
          "/italy/sicily/leopard-collection-historical-villas-in-sicily",
          "/italy/sicily/north-coast/villas-on-the-north-coast-of-sicily",
          "/italy/sicily/seafront-villas-in-sicily",
          "/italy/sicily/sicily-villas-near-restaurants",
          "/italy/sicily/villas-in-eastern-sicily",
          "/italy/sicily/villas-in-scopello",
          "/italy/sicily/villas-in-sicily-for-nature-lovers",
          "/italy/sicily/villas-in-sicily-near-cefalu",
          "/italy/sicily/villas-in-sicily-near-noto",
          "/italy/sicily/villas-in-sicily-near-palermo",
          "/italy/sicily/villas-in-sicily-with-pools",
          "/italy/sicily/villas-in-sicily-with-reduced-occupancy-rates",
          "/italy/sicily/villas-in-taormina",
          "/italy/sicily/villas-in-the-egadi-islands",
          "/italy/sicily/villas-in-the-northwest-of-sicily",
          "/italy/sicily/villas-in-the-south-east-of-sicily",
          "/italy/sicily/villas-in-the-west-and-southwest-of-sicily",
          "/italy/sicily/villas-in-the-west-of-sicily",
          "/italy/sicily/villas-near-catania-in-sicily",
          "/italy/sicily/villas-near-marsala",
          "/italy/sicily/villas-near-menfi",
          "/italy/sicily/villas-near-siracusa-in-sicily",
          "/italy/sicily/villas-on-or-near-mount-etna",
          "/italy/sicily/villas-on-sicily's-east-coast-ionian-riviera",
          "/italy/sicily/villas-on-the-aeolian-islands",
          "/italy/sicily/white-lotus-settings",
          "/italy/tuscany/villas-in-tuscany",
          "/large-villas-in-italy",
          "/large-villas-in-the-mediterranean",
          "/last-minute-villas",
          "/late-summer-villas",
          "/long-stay-villas",
          "/masserie-in-italy",
          "/memory-making",
          "/modern-design-villas-greece",
          "/new-destination-villas",
          "/new-villas-in-our-collection",
          "/places-with-soul",
          "/romantic-and-honeymoon-villas-in-the-mediterranean",
          "/secluded-relaxing-villas",
          "/secluded-villas-in-greece",
          "/sister-villas",
          "/small-greek-villas",
          "/small-italian-villas",
          "/summer-mediterranean-villas",
          "/the-architect-collection",
          "/the-discoverer",
          "/the-thinking-traveller-piper",
          "/think-exquisite-villas-in-the-mediterranean",
          "/travelling-with-a-conscience",
          "/villa-holidays-2024",
          "/villa-holidays-2025",
          "/villas-available-october-half-term",
          "/villas-close-to-town",
          "/villas-for-christmas-in-the-mediterranean",
          "/villas-for-families",
          "/villas-for-new-years-eve-in-the-mediterranean",
          "/villas-for-springtime",
          "/villas-for-thanksgiving-in-the-mediterranean",
          "/villas-for-working-from-home-greece",
          "/villas-in-greece",
          "/villas-in-italy",
          "/villas-in-mainland-greece",
          "/villas-in-the-countryside",
          "/villas-in-the-cyclades-islands",
          "/villas-on-the-cyclades-islands",
          "/villas-in-the-mediterranean-for-couples",
          "/villas-in-the-mediterranean-for-families-with-children-aged-6-to-12",
          "/villas-in-the-mediterranean-for-families-with-young-children",
          "/villas-in-the-mediterranean-for-gastronomic-adventures",
          "/villas-in-the-mediterranean-for-nature-lovers-and-keen-walkers",
          "/villas-in-the-mediterranean-for-two-families-to-share",
          "/villas-in-the-mediterranean-with-1-to-2-bedrooms",
          "/villas-in-the-mediterranean-with-an-easy-walk-to-the-beach",
          "/villas-in-the-mediterranean-with-daily-service-as-standard",
          "/villas-in-the-mediterranean-with-pools",
          "/villas-in-the-mediterranean-with-private-cinemas",
          "/villas-in-the-mediterranean-with-spa-wellness-and-gym-facilities",
          "/villas-in-the-mediterranean-with-vegetable-gardens",
          "/villas-in-the-mediterranean",
          "/villas-in-the-southwest-of-sicily",
          "/villas-near-a-golf-course",
          "/villas-on-paxos-and-antipaxos",
          "/villas-on-the-saronic-islands",
          "/villas-on-the-sporades-islands",
          "/villas-perfect-for-working-from-home",
          "/villas-with-an-infinity-pool",
          "/villas-with-authentic-soul",
          "/villas-with-cook-included",
          "/villas-with-exceptional-gardens",
          "/villas-with-four-consecutive-weeks-available",
          "/villas-with-jacuzzis-or-hot-tubs",
          "/villas-with-reduced-prices-for-small-groups",
          "/villas-with-the-best-addresses-in-town",
          "/villas-with-three-consecutive-weeks-available",
          "/villas-with-two-consecutive-weeks-available",
          "/villas-with-virtual-tour",
          "/when-only-the-best-will-do",
          "/winter-in-the-mediterranean",
          "/winter-villas-with-heatable-pools",
          "/winter-villas-with-spa-facilities"
        ];

        if (href.path) {
          if (
            !href.path.includes("http") &&
            !href.path.includes("tel:") &&
            !href.path.includes("mailto:") &&
            !href.path.includes(".pdf") &&
            // Splash pages - starts with
            !href.path.startsWith("/blog") &&
            !href.path.startsWith("/results") &&
            !href.path.startsWith("/enquiries") &&
            !href.path.startsWith("/experiences") &&
            !href.path.startsWith("/italy/sicily/experiences") &&
            !href.path.startsWith("/italy/puglia/experiences") &&
            !href.path.startsWith("/france/corsica/experiences") &&
            !href.path.startsWith("/greece/alonissos/experiences") &&
            !href.path.startsWith("/greece/corfu/experiences") &&
            !href.path.startsWith("/greece/kastos/experiences") &&
            !href.path.startsWith("/greece/lefkada/experiences") &&
            !href.path.startsWith("/greece/meganissi/experiences") &&
            !href.path.startsWith(
              "/greece/paxos-and-antipaxos/experiences"
            ) &&
            !href.path.startsWith("/greece/skopelos/experiences") &&
            !href.path.startsWith("/greece/zakynthos/experiences") &&
            !href.path.startsWith("/careers") &&
            !href.path.startsWith("/italy/sicily/villas/") &&
            !href.path.startsWith("/italy/puglia/villas/") &&
            !href.path.startsWith("/italy/tuscany/villas/") &&
            !href.path.startsWith("/france/corsica/villas/") &&
            !href.path.startsWith("/greece/evia/villas/") &&
            !href.path.startsWith("/greece/porto-heli/villas/") &&
            !href.path.startsWith("/greece/antiparos/villas/") &&
            !href.path.startsWith("/greece/kea/villas/") &&
            !href.path.startsWith("/greece/mykonos/villas/") &&
            !href.path.startsWith("/greece/paros/villas/") &&
            !href.path.startsWith("/greece/serifos/villas/") &&
            !href.path.startsWith("/greece/syros/villas/") &&
            !href.path.startsWith("/greece/tinos/villas/") &&
            !href.path.startsWith("/greece/patmos/villas/") &&
            !href.path.startsWith("/greece/aegina/villas/") &&
            !href.path.startsWith("/greece/hydra/villas/") &&
            !href.path.startsWith("/greece/spetses/villas/") &&
            !href.path.startsWith("/greece/alonissos/villas/") &&
            !href.path.startsWith("/greece/skiathos/villas/") &&
            !href.path.startsWith("/greece/skopelos/villas/") &&
            !href.path.startsWith("/greece/zakynthos/villas/") &&
            !href.path.startsWith("/greece/lefkada/villas/") &&
            !href.path.startsWith("/greece/paxos/villas/") &&
            !href.path.startsWith("/greece/kastos/villas/") &&
            !href.path.startsWith("/greece/meganissi/villas/") &&
            !href.path.startsWith("/greece/antipaxos/villas/") &&
            !href.path.startsWith("/greece/corfu/villas/") &&
            !href.path.startsWith("/greece/kefalonia/villas/") &&
            // Travel to and around/ Car hire:
            !href.path.startsWith(
              "/italy/sicily/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/italy/puglia/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/italy/tuscany/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/france/corsica/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/evia/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/porto-heli/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/antiparos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/kea/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/mykonos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/paros/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/serifos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/syros/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/tinos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/patmos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/aegina/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/hydra/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/spetses/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/alonissos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/skiathos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/skopelos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/zakynthos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/lefkada/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/paxos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/kastos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/meganissi/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/antipaxos/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/corfu/travel-to-and-around/"
            ) &&
            !href.path.startsWith(
              "/greece/kefalonia/travel-to-and-around/"
            ) &&
            !href.path.startsWith("/travel-agents") &&
            !href.path.startsWith("/booking-your-holiday") &&
            !href.path.startsWith("/faq") &&
            !href.path.startsWith("/account") &&
            // Splash pages - if exactly matches
            !exactMatchSafeList.includes(href.path)
          ) {
            $event.preventDefault();
            this.closeTab();
            window.scrollTo(0, 0);
            this.$router.push({ path: href.path });
          }
        }
      }
    },

    findHref(target, href, deep, ideep) {
      if (target && target.tagName && target.tagName.toLowerCase() === "a") {
        href.path = target.getAttribute("href");
      } else if (target && target.tagName && ideep < deep) {
        this.findHref(target.parentNode, href, deep, ideep++);
      }
    },

    navigateToPath(toPath) {
      this.$router.push({
        path: toPath
      });
      window.scrollTo(0, 0);
    },

    navigateToPage(id, type) {
      this.$router.push({
        path: this.$store.getters["applinks/getLink"](type, id).url
      });
      window.scrollTo(0, 0);
    }
  }
};
